<script setup>
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { FormCard, FormSwitch } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import UpdateAutomaticSourcesFormPart from "./UpdateAutomaticSourcesFormPart.vue";
import UpdateAutomaticLengthFormPart from "./UpdateAutomaticLengthFormPart.vue";
import UpdateAutomaticOrderByFormPart from "./UpdateAutomaticOrderByFormPart.vue";
import UpdateAutomaticPositionsFormPart from "./UpdateAutomaticPositionsFormPart.vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();

const form = useForm(props.settings);

const sources = [
    {
        key: "categories",
        name: __("Catégories"),
        description: __("Afficher les articles de la même catégorie."),
    },
    {
        key: "tags",
        name: __("Étiquettes"),
        description: __("Afficher les articles avec les mêmes étiquettes."),
    },
];

const submit = () => {
    if (form.processing) return;
    form.post("linking_automatic_posts_update_settings");
};
</script>

<template>
    <FormCard :title="__('Related Content pour les articles')">
        <form @submit.prevent="submit">
            <div class="mt-6 space-y-6">
                <FormSwitch v-model="form.enabled">{{ __("Activer l'affichage des articles similaires") }}</FormSwitch>

                <UpdateAutomaticSourcesFormPart v-model="form" :sources="sources" />

                <UpdateAutomaticLengthFormPart v-model="form" />

                <UpdateAutomaticOrderByFormPart v-model="form" />

                <UpdateAutomaticPositionsFormPart v-model="form" />
            </div>

            <div class="flex justify-end items-center mt-6">
                <ActionMessage :on="form.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>

                <PrimaryButton :processing="form.processing"> {{ __("Sauvegarder") }} </PrimaryButton>
            </div>
        </form>
    </FormCard>
</template>
